// open modal
const openModal = (target, callback) => {
  target = $(target)
  target.show()
  setTimeout(() => {
    target.addClass('is-show')
    $('body').addClass('is-locked')
    if (callback && typeof callback === 'function') {
      callback()
    }
  }, 50)
}

// close modal
const closeModal = (target, callback) => {
  target = $(target)
  const hideHandler = () => {
    target.hide()
    target.off('transitionend', hideHandler)
    $('body').removeClass('is-locked')
    if (callback && typeof callback === 'function') {
      callback()
    }
  }
  target.on('transitionend', hideHandler)
  target.removeClass('is-show')
}

// modal control
const useModalControl = () => {
  const openCallers = $('[data-modal-open]')
  const closeCallers = $('[data-modal-close]')

  openCallers.each((i, el) => {
    if (el.openModalEvent) return;
    const self = $(el)
    const target = $(el).attr('data-modal-open')
    self.on('click', () => openModal(target))
    el.openModalEvent = true
  })

  closeCallers.each((i, el) => {
    if (el.closeModalEvent) return;
    const self = $(el)
    const target = $(el).attr('data-modal-close')
    self.on('click', e => {
      const isPrevent = $(e.target).closest('[data-modal-prevent]').length
      if (isPrevent) return;
      closeModal(target)
    })
    el.closeModalEvent = true
  })
}


export {
  openModal,
  closeModal,
  useModalControl
}
